export default class ResponsibilityPerformance {
  constructor() {
    this.performers = {
      count: 0,
      atypical: 0,
    }
  
    this.contributors = {
      count: 0,
      atypical: 0,
    }
  }

  addPerformer(atypical=false) {
    this.performers.count++;
    if (atypical) this.performers.atypical++;
  }

  addContributor(atypical=false) {
    this.contributors.count++;
    if (atypical) this.contributors.atypical++;
  }

  get performed() {
    throw new Error("Not implemented");
  }
}